import { useEffect } from 'react';
import { JarallaxOptions } from 'jarallax';

type useJarallaxProps = {
    isEnabled: boolean;
    backgroundElement: any;
    config: JarallaxOptions;
    backgroundType?: string;
};

export function useJarallax(props: useJarallaxProps) {
    useEffect(() => {
        let jarallax;
        let jarallaxVideo;

        if (!props.isEnabled) {
            return;
        }

        const parallaxElement = props.backgroundElement.current;

        if (props.backgroundType === 'video') {
            ({ jarallax, jarallaxVideo } = require('jarallax'));

            jarallaxVideo();
            jarallax(parallaxElement, props.config);
        } else {
            ({ jarallax } = require('jarallax'));
            jarallax(parallaxElement, props.config);
        }
    }, [props.backgroundElement, props.config, props.backgroundType, props.isEnabled]);
}
